<template>
    <v-container
      fluid
      class="footer black"
    >
      <v-row>
        <v-col cols="12" class="text-center custom-gray py-0">
          <v-row>
            <v-col 
                v-for="(content, i) in contents"
                :key="`nugget-${ i }`"
                :cols="$mq.desktop ? 12 / contents.length : '12'"
                :style="!!content.img ? image( content ) : ''"
                class="d-flex px-10 py-10"
                :class="content.background ? content.background : ''"
                 :id="!!content.name ? content.name : ''"
            >
              <v-card
                class="flex-fill transparent"
                :class="$mq.desktop ? 'px-10' : ''"
                tile
                flat
              >
                <v-card-title v-if="!!content.title">
                    <h4 
                      class="custom-white-text d-flex flex-fill" 
                      :class="$mq.phone ? 'justify-center' : 'justify-start text-left'"
                    >{{ content.title }}</h4>
                </v-card-title>
                
                <v-card-text 
                  v-if="!content.sMedias" 
                  class="custom-white-text text-left"
                >
                  <ContentLists
                    v-if="!!content.list"
                    :list="{  
                      ...content.list, 
                      textColor: 'custom-white-text',
                      name: content.name,
                    }"
                  />
                </v-card-text>

                <v-card-text 
                  v-if="!!content.sMedias" 
                  class="d-flex flex-fill justify-center"
                  :class="$mq.desktop ? 'pa-10' : ''"
                >
                  <div 
                      v-for="(item, i) in content.sMedias" 
                      :key="`social-medias-button-${ i }`"
                  >
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                          link
                          text
                          :href="item.link"
                        >
                          <v-list-item-content
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon 
                              class="custom-white-text"
                              large
                            >mdi-{{ item.icon }}</v-icon>
                          </v-list-item-content>
                        </v-btn>
                      </template>

                      <span>{{ item.title }}</span>
                    </v-tooltip>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        
        <v-col cols="12">
          <div class="d-flex align-center justify-center">     
            <a class="ml-3 white--text" href="/privacy"><small>Politique de confidentialité</small></a>
            <a class="ml-3 white--text" href="/terms"><small>Conditions d'utilisation</small></a> 
            <small class="custom-white-text ml-5">
              <v-icon class="ml-1 custom-white-text" small>mdi-copyright</v-icon>{{ new Date().getFullYear() }} {{ url }}
            </small>       
            <small class="custom-white-text ml-3">Tous droits réservés</small> 
          </div>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import ContentLists from '@/components/ContentLists'

export default {
  name: 'Footer',
  components: {
    ContentLists
  },
  computed: {},
  data() {
    return {
      org: process.env.VUE_APP_ORG,
      url: process.env.VUE_APP_WEBSITE_URL, 
      contents: [
        {
            name: `upcoming`,
            title: `À venir sur ce site`,
            list: {
                title: `De nouveaux modèles de mobilier tels que:`,
                items: [
                    `Foyer extérieur à bois`,
                    `Foyer extérieur au gaz`,
                    `Muret (clôture)`,
                    `Structures préfabriquées`
                ]
            },
        },
        {
            name: 'media-releases',
            background: `semi-black`,
            title: `À lire aussi`,
            list: {
                noEol: true,
                items: [
                    {
                        tag: `a`,
                        href: `https://maisonsaine.ca/bioconstruction/les-murs-de-terre-pour-le-confort-et-la-sante.html`,
                        target: `_blank`,
                        title: `Parution dans le magazine Maison Saine`,
                        text: `On parle de nous dans le magazine Maison Saine`,
                        class: this.textColor,
                    }
                ]
            },
        },/* 
        {
          title: `Rejoignez-nous sur les médias sociaux!`,
          background: `gray-75`,
          sMedias: [
            {
              title: 'Twitter',
              icon: 'twitter',
              color: '#1da1f2',
              link: '#',
            },
            {
              title: 'LinkedIn',
              icon: 'linkedin',
              color: '#0e76a8',
              link: '#',
            },
            {
              title: 'Facebook',
              icon: 'facebook',
              color: '#3b5998',
              link: '#',
            },
          ],
        } */
      ],
    }
  },
}
</script>

<style>
.footer {
  z-index: 100;
  padding: 0;
}
</style>